<template>
  <div id="app">
      <v-nav></v-nav>
        <router-view v-if="isRouterAlive"/>
  </div>
</template>
<script>
    import VNav from "./components/Nav/VNav";
    import store from './store';
    import {mapState} from 'vuex';
    export default {
        components: {VNav},
        name: "app",
        provide() {
            return {
                reload: this.reload
            }
        },
        data(){
            return {
                isRouterAlive: true,
                pingTime: 0,//服务端心跳时间戳
                socketTimer: null
            }
        },
        mounted(){
          if(this.user.username !== ''  && window.localStorage.getItem('jwt-token')){
            this.initWebpack();
            this.webSocketWatch();
          }
        },
        beforeDestroy() {
            if(this.websock){
              this.websock.close();
            }
            clearInterval(this.socketTimer);
            this.socketTimer = null;
        },
        methods: {
            reload() {
                let that = this;
                this.isRouterAlive = false;
                this.$nextTick(function () {
                    that.isRouterAlive = true;
                })
            },
            //websocket心跳间隔计时器
            webSocketWatch() {
                let that = this;
                this.socketTimer = setInterval(function () {
                    that.pingTime = that.pingTime + 5;
                },5000)
            },
            initWebpack(){//初始化websocket
                let wsuri = this.$axios.defaults.baseWS + '/ws/client/otc/1111';
                //console.log(wsuri);
                this.websock = new WebSocket(wsuri);
                this.websock.onopen = this.websocketopen;
                this.websock.onmessage = this.websocketonmessage;
                this.websock.onerror = this.websocketerror;
            },
            websocketopen(){//打开
                //console.log("WebSocket连接成功11111");
                let jwtToken = localStorage.getItem('jwt-token').split(' ')[1];
                //console.log(jwtToken);
                this.websock.send(JSON.stringify({sub: 'otc.order', jwtToken: jwtToken}));
            },
            websocketonmessage(e){ //数据接收
                // console.log(e);
                let retData = JSON.parse(e.data);
                if (retData.ping) {
                    this.pingTime = 0;
                    this.websock.send(JSON.stringify({pong: retData.ping}));
                }else if(retData.msgType === 'data'){
                    let _this = this;
                    let res = JSON.parse(retData.data);
                    let operateType = res.operateType;
                    let orderDetail = res.orderDetail;
                    let orderStatus = res.orderStatus;
                    let otcOldOrderStatus = orderStatus.otcOldOrderStatus;
                    let otcOrderStatus = orderStatus.otcOrderStatus;
                    let orderFlowId = orderStatus.orderFlowId;//订单号
                    let _side = orderDetail.side;
                    console.log(res);
                    //console.log(_side);
                    //console.log(orderDetail);
                    //console.log(this.user.userId);
                    store.commit('updateWsOrderData',res);
                    if(operateType === 'user' && orderDetail.userId === this.user.userId){
                        //console.log(operateType);
                        if(otcOrderStatus === 'accept'){
                            this.$notify({
                              title: '订单'+orderFlowId,
                              message: '已接单',
                              duration: 0
                            });
                        }else if(_side === 'buy' && otcOrderStatus === 'confirm'){
                            this.$notify({
                              title: '订单'+orderFlowId,
                              message: '已完成',
                              duration: 0
                            });
                        }else if(otcOrderStatus === 'refuse'){
                            this.$notify({
                              title: '订单'+orderFlowId,
                              message: '已拒绝',
                              duration: 0
                            });
                        }else if(otcOrderStatus === 'timeout'){
                            this.$notify({
                              title: '订单'+orderFlowId,
                              message: '接单超时',
                              duration: 0
                            });
                        }else if(_side === 'sell' && otcOrderStatus === 'paid'){
                            this.$notify({
                              title: '订单'+orderFlowId,
                              message: '已付款',
                              duration: 0
                            });
                        }else if(_side === 'sell' && otcOrderStatus === 'cancel'){
                            this.$notify({
                              title: '订单'+orderFlowId,
                              message: '已取消',
                              duration: 0
                            });
                        }
                    }else if(operateType === 'business' && orderDetail.advUserId === this.user.userId){
                        //console.log(operateType);
                        if(otcOrderStatus === 'create'){
                            this.$notify({
                              title: '订单'+orderFlowId,
                              message: '已下单',
                              duration: 0
                            });
                        }else if(_side === 'buy' && otcOrderStatus === 'paid'){
                            this.$notify({
                              title: '订单'+orderFlowId,
                              message: '已付款',
                              duration: 0
                            });
                        }else if(_side === 'buy' && otcOrderStatus === 'cancel'){
                            this.$notify({
                              title: '订单'+orderFlowId,
                              message: '已取消',
                              duration: 0
                            });
                        }else if(otcOrderStatus === 'timeout'){
                            this.$notify({
                              title: '订单'+orderFlowId,
                              message: '接单超时',
                              duration: 0
                            });
                        }else if(_side === 'sell' && otcOrderStatus === 'confirm'){
                            this.$notify({
                              title: '订单'+orderFlowId,
                              message: '已完成',
                              duration: 0
                            });
                        }
                    }

                }


            },
            websocketerror(){ //失败
                //console.log("WebSocket连接失败");
            }
        },
        watch: {
            pingTime() {
                if (this.pingTime >= 30) {
                    this.websock.close();
                    this.initWebpack();
                    this.pingTime = 0;
                }
            },
            'user.username':function(){
                if(this.user.username === '' || !window.localStorage.getItem('jwt-token')){
                    if(this.websock){
                      this.websock.close();
                    }
                    clearInterval(this.socketTimer);
                    this.socketTimer = null;
                }else{
                    if(this.websock){
                      this.websock.close();
                    }
                    this.initWebpack();
                    this.pingTime = 0;
                }
            }
        },
        computed:{
            ...mapState({
                user: 'user',
                errorCode: 'errorCode'
            })
        }
    }
</script>
<style lang="less" scoped>
#app {
    height: 100%;
}
</style>
